import React from 'react';
import SendGridLink from '../SendGridLink';
import FooterLinks from './FooterLinks';
import {
  PRODUCTS,
  SENDGRID_IS_FOR,
  RESOURCES,
  DEVELOPERS,
  COMPANY,
} from '../../constants/footernav';
import SocialUL from './SocialUl';
import {
  StyledFooter,
  StyledFooterBottom,
  StyledUl,
  StyledFooterGrid,
} from './styles';

const Footer = () => (
  <StyledFooter>
    <div className="row row--large">
      <StyledFooterGrid>
        <div>
          <div className="m-bottom-5 color-gray-700 is-bold">Products</div>
          <FooterLinks menu={PRODUCTS} />
          <SendGridLink to="/solutions" className="arrow-link">
            View all Products
          </SendGridLink>
        </div>
        <div>
          <div className="m-bottom-5 color-gray-700 is-bold">
            SendGrid is For
          </div>
          <FooterLinks menu={SENDGRID_IS_FOR} />
          <SendGridLink to="/customers" className="arrow-link">
            Our Customers
          </SendGridLink>
        </div>
        <div>
          <div className="m-bottom-5 color-gray-700 is-bold">Resources</div>
          <FooterLinks menu={RESOURCES} />
          <SendGridLink
            to="https://support.sendgrid.com/hc/en-us"
            className="arrow-link"
          >
            Contact Support
          </SendGridLink>
        </div>
        <div>
          <div className="m-bottom-5 color-gray-700 is-bold">Developers</div>
          <FooterLinks menu={DEVELOPERS} />
          <SendGridLink
            to="https://sendgrid.com/docs/for-developers"
            className="arrow-link"
          >
            Go to Docs
          </SendGridLink>
        </div>
        <div>
          <div className="m-bottom-5 color-gray-700 is-bold">Company</div>
          <FooterLinks menu={COMPANY} />
          <SendGridLink
            to="https://support.sendgrid.com/hc/en-us"
            className="arrow-link"
          >
            Contact Us
          </SendGridLink>
        </div>
      </StyledFooterGrid>
    </div>
    <StyledFooterBottom>
      <div className="row row--large">
        <div className="grid grid-two-col--wide-left-col grid-gap-up3">
          <div>
            <StyledUl>
              <li>
                <SendGridLink to="/sitemap">Sitemap</SendGridLink>
              </li>
              <li>
                <SendGridLink to="/policies/privacy">
                  Privacy Policy
                </SendGridLink>
              </li>
              <li>
                <a href="https://www.twilio.com/legal/tos">Terms</a>
              </li>
              <li>{`Copyright ${new Date().getFullYear()} SendGrid`}</li>
            </StyledUl>
          </div>
          <div>
            <SocialUL />
          </div>
        </div>
      </div>
    </StyledFooterBottom>
  </StyledFooter>
);

export default Footer;
